import React, { useState } from 'react'
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton'
import MainLayout from '../Layouts/MainLayout'
import AdminPasswordUpdate from './AdminPasswordUpdate'

function MyAccountPasswordContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "My Account",
    navSubTitle: "Welcome to ImagesBazaar"
})
const [addUserModal, setAddUserModal] = useState(false)
const handleAddUserModal = (value=false) =>{
  setAddUserModal(value)
}

const handleNavParams = (obj)=>{
  setNavParams({
      ...navParams,
      ...obj
  })
}
  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <AdminPasswordUpdate handleNavParams={handleNavParams} />
    </MainLayout>
  )
}

export default MyAccountPasswordContainer